import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, ShieldAlert } from 'lucide-react';
import { getFirstAllowedPath, readUserInfo } from '../services/pageAccess';

const Forbidden = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = readUserInfo();
  const fromPath = location.state?.from;

  const goHome = () => {
    const allowed = JSON.parse(sessionStorage.getItem('ainsoft.allowedPageNames') || '[]');
    const firstAllowed = Array.isArray(allowed) ? getFirstAllowedPath(allowed) : null;
    navigate(firstAllowed || '/home', { replace: true });
  };

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-xl border border-red-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-600">
          <ShieldAlert className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Access Denied</h1>
        <p className="mt-3 text-sm text-gray-600">
          {userInfo?.UserName ? `${userInfo.UserName}, you` : 'You'} do not have permission to open this page.
        </p>
        {fromPath && (
          <p className="mt-2 text-xs text-gray-500">
            Requested page: <span className="font-medium text-gray-700">{fromPath}</span>
          </p>
        )}
        <button
          type="button"
          onClick={goHome}
          className="mt-6 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary/90"
        >
          <Home className="h-4 w-4" />
          Go to allowed page
        </button>
      </div>
    </div>
  );
};

export default Forbidden;
